import { render, staticRenderFns } from "./teacherlist.vue?vue&type=template&id=e8dd849a&"
import script from "./teacherlist.vue?vue&type=script&lang=js&"
export * from "./teacherlist.vue?vue&type=script&lang=js&"
import style0 from "./teacherlist.vue?vue&type=style&index=0&id=e8dd849a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports